import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getBiddingSpotScreen } from '@ebalance/proto/bffuser/v1/bidding_spot_service-BiddingSpotService_connectquery'
import {
  GetBiddingSpotScreenRequestSchema,
  type GetBiddingSpotScreenResponse,
} from '@ebalance/proto/bffuser/v1/bidding_spot_service_pb'
import type { Date as ProtoDate } from '@ebalance/proto/google/type/date_pb'
import type { UseQueryResult } from '@tanstack/react-query'

// The screen response contains editable bid details, so it deliberately does
// not poll. Approval-state projection queries trigger an event-driven refetch.
export function useGetBiddingSpotScreen(
  targetDate: ProtoDate,
  options?: {
    /**
     * false の間は RPC を発火しない (issue #7131 / AC-WFW-006a Decision 1:
     * ワークフローケース対象日が確定するまで対象日依存のデータ取得を開始しない)。
     * 省略時は従来どおり常時有効 (= 後方互換)。
     */
    enabled?: boolean
  },
): UseQueryResult<GetBiddingSpotScreenResponse, ConnectError> {
  return useQuery(
    getBiddingSpotScreen,
    create(GetBiddingSpotScreenRequestSchema, { targetDate }),
    { enabled: options?.enabled, throwOnError: false },
  )
}
